// import createPersistedState from 'vuex-persistedstate'
import Vue from 'vue';

export const state = () => ({
  viewportWidth: 0,
  viewportHeight: 0,
  scrollPosition: 0,
});

export const plugins = [
];

export const mutations = {
  setViewportWidth(state, value) {
    state.viewportWidth = value;
  },
  setViewportHeight(state, value) {
    state.viewportHeight = value;
  },
  setScrollPosition(state, value) {
    state.scrollPosition = value;
  }
};

export const actions = {
  showRequestError(context, error) {
    console.error('catched:', error.parsedData);
  },
  showRequestSuccess(context, { title, message }) {
    console.log(title, message);
  },
  showWarning(context, { title, message }) {
    console.warn(title, message);
  },
  nuxtServerInit({dispatch}) {
   // dispatch('main/mainContent')
  }
};

export const strict = false;



// WEBPACK FOOTER //
// ./store/index.js